import { render } from "./FacultyWorkloadDialog.vue?vue&type=template&id=c74f8ed6"
import script from "./FacultyWorkloadDialog.vue?vue&type=script&lang=js"
export * from "./FacultyWorkloadDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__